var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status === true)?_c('b-badge',{attrs:{"variant":"light-success"}},[_vm._v(" Đang chạy ")]):_c('b-badge',{attrs:{"variant":"light-danger"}},[_vm._v(" Đang dừng ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }